import React from 'react';
import {
  FormPageInputItemMonthDay,
  FormPageInputItemMonthDayFree,
  MonthDayProperty,
  MonthDayPropertyFree,
  MONTH_DAY_PROPERTY_INPUT_TYPE,
  MonthDayPropertyPulldown,
  FormPageInputItemMonthDayPulldown,
} from 'shared';
import { FormFieldInputProps, hasErrorMessage } from '../shared';
import { MonthDayFree } from './MonthDayFree';
import { MonthDayPulldown } from './MonthDayPulldown';

export type MonthDayInputProps = FormFieldInputProps<
  MonthDayProperty,
  FormPageInputItemMonthDay
>;

const isError = (
  errorMessages: MonthDayInputProps['errorMessages'],
  displayError = false
): boolean => !!displayError && hasErrorMessage(errorMessages);

export const MonthDayInput: React.FC<MonthDayInputProps> = (props) => {
  switch (props.property.inputFormat.inputType) {
    case MONTH_DAY_PROPERTY_INPUT_TYPE.free: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          MonthDayPropertyFree,
          FormPageInputItemMonthDayFree
        >;
      const displayError =
        submitted || (touched && touched.month && touched.day);
      return (
        <MonthDayFree
          monthValue={value.month}
          dayValue={value.day}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case MONTH_DAY_PROPERTY_INPUT_TYPE.pulldown: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          MonthDayPropertyPulldown,
          FormPageInputItemMonthDayPulldown
        >;
      const displayError =
        submitted || (touched && touched.month && touched.day);
      return (
        <MonthDayPulldown
          monthValue={value.month}
          dayValue={value.day}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
  }
};
